import {
    OUTLOOK_BEAUTIFIED_PREFIX,
    OUTLOOK_BEAUTIFIED_IMAGE_PREFIX,
    isThumbnailViewSupported,
} from 'owa-attachment-link-common';
import type AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export function addBeautifiedPrefixToId(
    anchorElement: HTMLAnchorElement,
    fileName: string,
    providerType: AttachmentDataProviderType
) {
    if (isThumbnailViewSupported(fileName, providerType)) {
        anchorElement.id = OUTLOOK_BEAUTIFIED_IMAGE_PREFIX + anchorElement.id;
    } else {
        anchorElement.id = OUTLOOK_BEAUTIFIED_PREFIX + anchorElement.id;
    }
}
